/**
 * @fileoverview GET handler for the "/engagement/webhook_templates/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesTags } from "./constants";
import type { EngagementWebhookTemplatesTagsResult } from "./types";

export const getEngagementWebhookTemplatesTags = reactQueryFetcherAdapter(
  engagementWebhookTemplatesTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementWebhookTemplatesTagsResult> => {
    return fetch("/engagement/webhook_templates/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
